// Full submenu for master users (appears in Lotto section)
export default [
  {
    title: 'ตรวจจับการปั้ม',
    icon: 'EyeIcon',
    action: ['read'],
    resource: 'lotto',
    children: [
      {
        title: 'ตั้งค่า',
        route: 'fraud-detection-config',
        action: ['read'],
        resource: 'lotto',
      },
      {
        title: 'รายการน่าสงสัย',
        route: 'fraud-detection-activities',
        action: ['read'],
        resource: 'lotto',
      },
    ],
  },
]
